module.exports = __webpack_public_path__ + "img/danger.434be004.svg";